module.exports = __webpack_public_path__ + "img/26.8ea2f107.jpg";